export const Rights = {
    Tenants: 1,
    Clients: 2,
    Users: 4,
    Configurations: 8,
    Events: 16,
    EventTypes: 32,
    EventVenues: 64,
    EventSponsors: 128,
    MilitaryJobs: 256,
    FeaturedJobs: 512,
    PrefilteredLinks: 1024,
    TalentNetworkData: 2048,
    Feeds: 4096,
    OutboundFeeds: 8192,
    Locations: 16384,
    Resumes: 32768,
    ConnectBillings: 65536,
}